import { useEffect, useState, useContext } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import Footer from "./footer/footer";
import { MemoizedCookies } from "./cookies";
import BlogHeader from "./blog/blog_header/blog_header";
import ArticleHeader from "./blog/article_header/article_header";
import { GlobalContext } from "../stores/use_global_state";
import { checkAvailability } from "../pages/api/api.js";

const DynamicError = dynamic(() => import("./error/error"), {
  ssr: false,
});

export default function BlogLayout({ children, mainClassName = "", categories = [], isMainPage = false }) {
  const router = useRouter();
  const { state, dispatch } = useContext(GlobalContext);
  const [showAdaptiveBtn, setShowAdaptiveBtn] = useState(true);
  const [showFooter, setShowFooter] = useState(false);

  const editorAdaptive =
    router.pathname.split("/").includes("remove-video-bg") ||
    router.pathname.split("/").includes("turn-photo-into-video");

  useEffect(
    () => {
      const startCheckAvailability = async () => {
        let check = await checkAvailability();
        if (check.maintenance) {
          dispatch({ type: "setVideoError", error_msg: "isTemporarilyUnavailable", error_code: "unavailable", });
          router.push({ pathname: "/error/" });
          return false;
        }
      };
      startCheckAvailability();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    () => {
      let { pathname } = router;

      setShowFooter(
        !pathname.split("/").includes("sign-in") &&
        !pathname.split("/").includes("sign-up") &&
        !pathname.split("/").includes("thank") &&
        !pathname.split("/").includes("forgot-password")
      );

      if (pathname === "/") {
        setShowAdaptiveBtn(false);
      }

      const handleScroll = () => {
        if (pathname === "/") {
          const scrolledFromTop = window.pageYOffset;
          scrolledFromTop > 600 ? setShowAdaptiveBtn(true) : setShowAdaptiveBtn(false);
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className="AppWrapper">
      {state?.error_msg ? <DynamicError /> : null}

      {router.pathname === "/blog" || router.pathname.split("/").includes("categories") ? <BlogHeader categories={categories} isMainPage={isMainPage} /> : <ArticleHeader />}

      <main className={`main ${mainClassName} ${editorAdaptive ? "editor-adaptive" : ""}`}>
        {children}
      </main>
      {showFooter && <Footer editorAdaptive={editorAdaptive} showAdaptiveBtn={showAdaptiveBtn} />}
      <MemoizedCookies />
    </div>
  );
}
